import { REVIEW_STATUS, DETECTION_TYPES_CONFIG } from 'constants/av-review';

export const PER_PAGE = 10;

export const ALL_TAB_ID = 'all';

export const TEACHER_ID_DEBOUNCE_MS = 350;

export const STATUS_FILTERS = [
  { label: 'Assigned', status: REVIEW_STATUS.ASSIGNED },
  { label: 'In Progress', status: REVIEW_STATUS.IN_PROGRESS },
];

export const DETECTION_TYPE_OPTIONS = Object.entries(
  DETECTION_TYPES_CONFIG,
).map(([value, cfg]) => ({ value, label: cfg.label }));

export const ROW_STYLE = { cursor: 'pointer' };

export const STAT_CARDS = [
  { key: 'assigned', label: 'Assigned' },
  { key: 'in_progress', label: 'In progress' },
  { key: 'submitted_today', label: 'Submitted today' },
  { key: 'submitted_this_week', label: 'Submitted this week' },
  { key: 'submitted_this_month', label: 'Submitted this month' },
];
